import WidgetCard from "@arelia-components/ui-atoms/WidgetCard";
import AreaChart, { AreaChartProps } from "@arelia-components/ui-atoms/AreaChart";
import { StreamingInterval } from "@arelia-types/streaming";
import NavTabs from "@arelia-components/ui-atoms/NavTabs";
import { Box } from "@mui/system";

type Props = {
  widgetId: string;
  title: string;
  chartListeners: AreaChartProps;
  loading: boolean;
  error: boolean;
  period: StreamingInterval;
  unconnected: boolean;
  setPeriod: React.Dispatch<React.SetStateAction<StreamingInterval>>;
};

const options = [
  { value: StreamingInterval.daily, label: 'Daily' },
  { value: StreamingInterval.weekly, label: 'Weekly' },
  { value: StreamingInterval.monthly, label: 'Monthly' }
];

export default function StreamingChartPresenter({ widgetId, title, chartListeners, loading, error, period, unconnected, setPeriod
 }: Props) {
  const { data, labels, datasets } = chartListeners;

  return (
    <WidgetCard
      widgetId={widgetId}
      title={title}
      loading={loading}
      error={error}
      unconnected={unconnected}
      headerComponent={<NavTabs value={period} setValue={value => setPeriod(value as StreamingInterval)} options={options} />}
    >
      <Box flexGrow="1">
        <AreaChart data={data} labels={labels} datasets={datasets} />
      </Box>
    </WidgetCard>
  );
}
